import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import AMLayers from './AmTab';
import PMLayers from './PmTab';
import MidLayers from './MidTab';
import Box from '@material-ui/core/Box';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box b={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

//Start Css code ...
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    padding: '0px',
    '& .Mui-selected': {
      background: 'rgba(36, 97, 142, 1)',
      color: "#fff !important"
    },
    '& .MuiTabs-root': {
      minHeight: '25px',
      marginTop: "10px"
    },
    '& .MuiTabs-flexContainer': {
      display: 'inline-block',
    },
    '& .MuiTab-root': {
      minWidth: '140px',
      padding: '3px 15px 2px',
      lineHeight: 'normal',
    },
    '& .PrivateTabIndicator-colorPrimary-14': {
      backgroundColor: '#24618E',
    },
    '& .MuiAppBar-colorDefault': {
      marginBottom: '15px',
      boxShadow: 'none',
      background: '#fff',
      '& .MuiButtonBase-root': {
        border: '1px solid #24618E',
        borderRadius: '8px 8px 0px 0px',
        minHeight: 'auto',
        color: '#333',
        textTransform: 'capitalize',
        borderBottom: 'none',
      },
    },
    '& h5': {
      fontSize: '18px',
      margin: '0px 0 10px',
    },
    '& .MuiAppBar-root': {
      marginBottom: '0px !important'
    },
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent !important',
    }
  },
  layerBlock: {
    '& h4': {
      fontSize: '20px',
      margin: '10px 0',
    },
  },
  tabDisable: {
    // border: '1px solid #999999',
    backgroundColor: '#ffffff',
    color: '#666666',
    border: '1px solid grey',
    opacity: 0.5,
  },
  mainbtnDiv: {
    border: '1px solid rgba(0, 167, 93, 1)',
    borderTop: '1px solid rgba(0, 167, 93, 1)',
    borderRadius: '0px 5px 5px 5px',
    height: 'auto',
    '& .focusBtn': {
      color: "#fff",
      background: '#24618E',
    },
    '& .left': {
      width: '37%',
      float: 'left',
    },
    '& .right': {
      width: '63%',
      float: 'right',
    },
    overflow: "hidden",
    marginBottom: "5px"
  },
  intersectionDrop: {
    padding: '5px',
    fontSize: '14pt',
    width: '100%',
  },
  turningCountData: {
    '& span.amnbIn': {
      position: 'relative',
      top: '-365px',
      left: ' 140px',
    },
    '& span.amnbEx': {
      position: 'relative',
      top: '-365px',
      left: '195px',
    },
    '& span.amsbIn': {
      position: 'relative',
      top: '-35px',
      left: '162px',
    },
    '& span.amsbEx': {
      position: 'relative',
      top: '-35px',
      left: '47px',
    },
    '& span.amebIn': {
      position: 'relative',
      top: '-243px',
      left: '245px',
    },
    '& span.amebEx': {
      position: 'relative',
      top: '-158px',
      left: '214px',
    },
    '& span.amwbIn': {
      position: 'relative',
      top: '-157px',
      left: '-160px',
    },
    '& span.amwbIn': {
      position: 'relative',
      top: '-155px',
      left: '-175px',
    },
    '& span.amwbEx': {
      position: 'relative',
      top: '-240px',
      left: '-185px',
    },
    '& span.amNbLeft': {
      position: 'relative',
      top: '-305px',
      left: '20px',
    },
    '& span.amSbLeft': {
      position: 'relative',
      top: '-95px',
      left: '-82px',
    },
    '& span.amEbLeft': {
      position: 'relative',
      top: '-160px',
      left: '52px',
    },
    '& span.amWbLeft': {
      position: 'relative',
      top: '-238px',
      left: '-195px',
    },
    '& span.amNbRight': {
      position: 'relative',
      top: '-305px',
      left: '-130px',
    },
    '& span.amSbRight': {
      position: 'relative',
      top: '-95px',
      left: '-70px',
    },
    '& span.amEbRight': {
      position: 'relative',
      top: '-236px',
      left: '-30px',
    },
    '& span.amWbRight': {
      position: 'relative',
      top: '-160px',
      left: '-270px',
    },
    '& span.amCenterData': {
      position: 'relative',
      top: '-200px',
      left: '-177px',
    },
    '& span.amNbMiddle': {
      position: 'relative',
      top: '-305px',
      left: '-210px',
    },
    '& span.amSbMiddle': {
      position: 'relative',
      top: '-95px',
      left: '-245px',
    },
    '& span.amEbMiddle': {
      position: 'relative',
      top: '-196px',
      left: '-160px',
    },
    '& span.amWbMiddle': {
      position: 'relative',
      top: '-199px',
      left: '-390px',
    },
  },
  truckMovData: {
    '& span.amnbIn': {
      position: 'relative',
      top: '-375px',
      left: '145px',
    },
    '& span.amnbEx': {
      position: 'relative',
      top: '-375px',
      left: '206px',
    },
    '& span.amsbIn': {
      position: 'relative',
      top: '-25px',
      left: '190px',
    },
    '& span.amsbEx': {
      position: 'relative',
      top: '-25px',
      left: '80px',
    },
    '& span.amebIn': {
      position: 'relative',
      top: '-243px',
      left: '290px',
    },
    '& span.amebEx': {
      position: 'relative',
      top: '-158px',
      left: '265px',
    },
    '& span.amwbIn': {
      position: 'relative',
      top: '-157px',
      left: '-160px',
    },
    '& span.amwbIn': {
      position: 'relative',
      top: '-158px',
      left: '-140px',
    },
    '& span.amwbEx': {
      position: 'relative',
      top: '-245px',
      left: '-158px',
    },
    '& span.amNbLeft': {
      position: 'relative',
      top: '-315px',
      left: '45px',
    },
    '& span.amSbLeft': {
      position: 'relative',
      top: '-85px',
      left: '-82px',
    },
    '& span.amEbLeft': {
      position: 'relative',
      top: '-163px',
      left: '75px',
    },
    '& span.amWbLeft': {
      position: 'relative',
      top: '-245px',
      left: '-185px',
    },
    '& span.amNbRight': {
      position: 'relative',
      top: '-315px',
      left: '-130px',
    },
    '& span.amSbRight': {
      position: 'relative',
      top: '-85px',
      left: '-45px',
    },
    '& span.amEbRight': {
      position: 'relative',
      top: '-240px',
      left: '0px',
    },
    '& span.amWbRight': {
      position: 'relative',
      top: '-160px',
      left: '-264px',
    },
    '& span.amNbMiddle': {
      position: 'relative',
      top: '-315px',
      left: '-170px',
    },
    '& span.amSbMiddle': {
      position: 'relative',
      top: '-85px',
      left: '-196px',
    },
    '& span.amEbMiddle': {
      position: 'relative',
      top: '-203px',
      left: '-90px',
    },
    '& span.amWbMiddle': {
      position: 'relative',
      top: '-199px',
      left: '-343px',
    },
  },
  pedVolData: {
    '& span.amNbWalk': {
      position: 'relative',
      top: '-330px',
      left: '198px',
    },
    '& span.amSbWalk': {
      position: 'relative',
      top: '-83px',
      left: '185px',
    },
    '& span.amEbWalk': {
      position: 'relative',
      top: '-203px',
      left: '310px',
    },
    '& span.amWbWalk': {
      position: 'relative',
      top: '-204px',
      left: '20px',
    },
  },
  bicycleMovlData: {
    '& span.amNbLeft': {
      position: 'relative',
      top: '-315px',
      left: '235px',
    },
    '& span.amSbLeft': {
      position: 'relative',
      top: '-95px',
      left: '125px',
    },
    '& span.amEbLeft': {
      position: 'relative',
      top: '-170px',
      left: '285px',
    },
    '& span.amWbLeft': {
      position: 'relative',
      top: '-238px',
      left: '5px',
    },
    '& span.amNbRight': {
      position: 'relative',
      top: '-314px',
      left: '75px',
    },
    '& span.amSbRight': {
      position: 'relative',
      top: '-95px',
      left: '150px',
    },
    '& span.amEbRight': {
      position: 'relative',
      top: '-240px',
      left: '200px',
    },
    '& span.amWbRight': {
      position: 'relative',
      top: '-170px',
      left: '-70px',
    },
    '& span.amNbMiddle': {
      position: 'relative',
      top: '-315px',
      left: '40px',
    },
    '& span.amSbMiddle': {
      position: 'relative',
      top: '-95px',
      left: '7px',
    },
    '& span.amEbMiddle': {
      position: 'relative',
      top: '-202px',
      left: '105px',
    },
    '& span.amWbMiddle': {
      position: 'relative',
      top: '-204px',
      left: '-154px',
    },
  }

}));
//End Css code ...

//Start PopupTab component code ...
const PopupTab = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [getIntersectionDrop, setIntersectionDrop] = React.useState(null);
  const [getAMDisabled, setAMDisabled] = React.useState(false);
  const [getPMDisabled, setPMDisabled] = React.useState(false);
  const [getMIDDisable, setMIDDisable] = React.useState(false);
  React.useEffect(
    () => {
      let amCountData = props.AMdata && props.AMdata.count != null ? props.AMdata && props.AMdata.count : 0;
      let midCountData = props.MIDdata && props.MIDdata.count != null ? props.MIDdata && props.MIDdata.count : 0;
      let pmCountData = props.PMdata && props.PMdata.count != null ? props.PMdata && props.PMdata.count : 0;
      disableTab(amCountData, midCountData, pmCountData);
      let historyData = getIntersectionDrop !== null ? getIntersectionDrop : 0
      setIntersectionDrop(historyData);
    }, [props]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const onChangeMethod = (index) => {
    setIntersectionDrop(index);
  };

  //This function is used for disable Tab ... Start
  const disableTab = (amCountData, midCountData, pmCountData) => {
    if (amCountData === 0 && midCountData === 0 && pmCountData === 0) {
      setAMDisabled(true);
      setMIDDisable(true);
      setPMDisabled(true);
    }
    else if (amCountData === 0 && (midCountData !== 0 && pmCountData !== 0)) {
      handleChangeIndex(1);
      setAMDisabled(true);
      setMIDDisable(false);
      setPMDisabled(false);
    } else if ((amCountData !== 0 && midCountData !== 0) && pmCountData === 0) {
      handleChangeIndex(0);
      setAMDisabled(false);
      setMIDDisable(false);
      setPMDisabled(true);
    } else if ((amCountData !== 0 && pmCountData !== 0) && midCountData === 0) {
      handleChangeIndex(0);
      setAMDisabled(false);
      setMIDDisable(true);
      setPMDisabled(false);
    } else if ((amCountData === 0 && pmCountData === 0) && midCountData !== 0) {
      handleChangeIndex(1);
      setAMDisabled(true);
      setMIDDisable(false);
      setPMDisabled(true);
    }
    else if (amCountData !== 0 && (midCountData === 0 && pmCountData === 0)) {
      handleChangeIndex(0);
      setAMDisabled(false);
      setMIDDisable(true);
      setPMDisabled(true);
    } else if ((amCountData === 0 && midCountData === 0) && pmCountData !== 0) {
      handleChangeIndex(2);
      setAMDisabled(true);
      setMIDDisable(true);
      setPMDisabled(false);
    }
    else {
      setAMDisabled(false);
      setMIDDisable(false);
      setPMDisabled(false);
    }
  }
  //This function is used for disable Tab ... End

  return (
    <React.Fragment>
      <div className={classes.layerBlock}>
        <div className={classes.root} style={{ marginTop: '5px' }}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab className={getAMDisabled ? classes.tabDisable : null} label="AM" {...a11yProps(0)} disabled={getAMDisabled} />
              <Tab className={getMIDDisable ? classes.tabDisable : null} label="Mid" {...a11yProps(1)} disabled={getMIDDisable} />
              <Tab className={getPMDisabled ? classes.tabDisable : null} label="PM" {...a11yProps(2)} disabled={getPMDisabled} />
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} dir={theme.direction}>
              <AMLayers AMdata={props.AMdata} stationId={props.stationId} onChangeMethod={onChangeMethod} getIntersectionDrop={getIntersectionDrop} />
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction}>
              <MidLayers MIDdata={props.MIDdata} stationId={props.stationId} getIntersectionDrop={getIntersectionDrop} onChangeMethod={onChangeMethod} />
            </TabPanel>
            <TabPanel value={value} index={2} dir={theme.direction}>
              <PMLayers PMdata={props.PMdata} stationId={props.stationId} getIntersectionDrop={getIntersectionDrop} onChangeMethod={onChangeMethod} />
            </TabPanel>
          </SwipeableViews>
        </div>
      </div>
    </React.Fragment>
  );
}


export default PopupTab;
//End PopupTab component code ...
